<template>
  <div>
    <div class="read-fault-button">
      <span>{{ $t('ProductDiagnosis.ensureBatteryIsOn') }}</span>
    </div>

    <div class="table-container" ref="tableContainer" :key="tableKey">
      <!-- 固定滚动条占位 -->
      <div class="scrollbar-placeholder"></div>
      <div class="table-wrapper">
        <el-table v-loading="isLoading" element-loading-text="Loading..." :header-cell-style="{background:'rgb(250, 250, 250)'}" :data="faultData" style="width: 100%">
        <el-table-column :label="$t('ProductDiagnosis.sequenceNumber')" type="index" :min-width="100"></el-table-column>
        <el-table-column :label="$t('ProductDiagnosis.module')">
          <template v-slot="scope">
            {{ scope.row ? scope.row.moduleType : '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('ProductDiagnosis.errorCodeColumn')">
          <template v-slot="scope">
            {{ scope.row ? 'E' + scope.row.errCode : '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('ProductDiagnosis.faultName')" prop="errName"></el-table-column>

        <el-table-column :label="$t('ProductDiagnosis.faultDetails')" prop="detail" width="700px">
          <template v-slot="scope">
            <el-button link @click="viewHistoryDetails(scope.row)"><span
                class="link-text-style">{{ $t('ProductDiagnosis.view') }}</span>
            </el-button>
          </template>
        </el-table-column>

        <!-- 使用 empty 插槽显示图片 -->
        <template v-slot:empty>
          <EmptySlot/>
        </template>

      </el-table>
      </div>
    </div>

    <el-dialog v-model="historyDetailVisible" :width="700">
      <template #header>
        <div class="my-header">
          {{ $t('ProductDiagnosis.faultDetails') }}
        </div>
        <hr class="dialog-separator"/>

        <div class="flex-container">
          <div class="flex-item">
            <p>  <span class="custom-color err-name-large">{{
                motorErrorDetail?.errName || '-'
              }}</span></p>
            <p><span class="custom-color err-name-large">{{ motorErrorDetail?.errCode ? 'E' + motorErrorDetail.errCode : '-' }}</span></p>
          </div>
          <div class="flex-item">
            <p> {{ $t('ProductDiagnosis.faultTime') }} <span
                class="custom-color">{{ checkDate(motorErrorDetail?.date) }}</span></p>
          </div>
          <div class="flex-item">
            <p> {{ $t('ProductDiagnosis.totalFaultsCount') }} <span
                class="custom-color">{{ checkErrCount(motorErrorDetail?.errCount) }}</span></p>
          </div>
        </div>

        <div class="section">
          <hr class="dialog-separator"/>
          <div class="battery-flex-container">
            <div class="battery-flex-item">
              <p> {{ $t('ProductDiagnosis.gearValue') }} <span class="custom-color">{{
                  motorErrorDetail?.gearlevel !== null && motorErrorDetail.gearlevel !== '' && motorErrorDetail.gearlevel <= 10 && motorErrorDetail.gearlevel >= 0 ? motorErrorDetail.gearlevel : '-'
                }} </span></p>
            </div>
            <div class="battery-flex-item">
              <p>SOC <span class="custom-color">{{
                  motorErrorDetail?.batterquantity !== null && motorErrorDetail.batterquantity !== '' && motorErrorDetail.batterquantity >= 0  && motorErrorDetail.batterquantity <= 100 ? motorErrorDetail.batterquantity + ' %' : '-'
                }}</span></p>

            </div>
            <div class="battery-flex-item">
              <p>{{ $t('ProductDiagnosis.motorTemperature') }} <span class="custom-color">{{
                  motorErrorDetail?.temperature_motor !== null && motorErrorDetail.temperature_motor !== '' && motorErrorDetail.temperature_motor >= 0  && motorErrorDetail.temperature_motor <= 150 ? motorErrorDetail.temperature_motor + ' ℃' : '-'
                }}</span></p>

            </div>
            <div class="battery-flex-item">
              <p>{{ $t('ProductDiagnosis.speed') }} <span class="custom-color">{{
                  motorErrorDetail?.bikespeed !== null && motorErrorDetail.bikespeed !== '' && motorErrorDetail.bikespeed >= 0  && motorErrorDetail.bikespeed <= 100 ? motorErrorDetail.bikespeed + ' km/h' : '-'
                }}</span></p>
            </div>
            <div class="battery-flex-item">
              <p>{{ $t('ProductDiagnosis.BMSTemperature') }} <span class="custom-color">{{
                  motorErrorDetail?.temperature_BMS !== null && motorErrorDetail.temperature_BMS !== '' && motorErrorDetail.temperature_BMS >= 0 && motorErrorDetail.temperature_BMS <= 150 ? motorErrorDetail.temperature_BMS + ' ℃' : '-'
                }}</span></p>
            </div>
            <div class="battery-flex-item">
              <p>{{ $t('ProductDiagnosis.motorRPM') }} <span class="custom-color">{{
                  motorErrorDetail?.RPM !== null && motorErrorDetail.RPM !== '' && motorErrorDetail.RPM >= 0 && motorErrorDetail.RPM <= 500 ? motorErrorDetail.RPM + ' rpm' : '-'
                }}</span></p>

            </div>
            <div class="battery-flex-item">
              <p>{{ $t('ProductDiagnosis.cellTemperature') }} <span class="custom-color">{{
                  motorErrorDetail?.temperature_core !== null && motorErrorDetail.temperature_core !== '' && motorErrorDetail.temperature_core >= 0 && motorErrorDetail.temperature_core <= 150 ? motorErrorDetail.temperature_core + ' ℃' : '-'
                }}</span></p>

            </div>
            <div class="battery-flex-item">
              <p>{{ $t('ProductDiagnosis.busCurrent') }} <span class="custom-color">{{
                  motorErrorDetail?.busCurrent !== null && motorErrorDetail.busCurrent !== '' && motorErrorDetail.busCurrent >= 0 && motorErrorDetail.busCurrent <= 60? motorErrorDetail.busCurrent + ' A' : '-'
                }}</span></p>

            </div>
            <div class="battery-flex-item">
              <p>{{ $t('ProductDiagnosis.totalMileage') }} <span class="custom-color">{{
                  motorErrorDetail?.ODO !== null && motorErrorDetail.ODO !== '' && motorErrorDetail.ODO >= 0  && motorErrorDetail.ODO < 100000 ? motorErrorDetail.ODO + ' km' : '-'
                }}</span></p>

            </div>
            <div class="battery-flex-item">
              <p>{{ $t('ProductDiagnosis.controllerTemperature') }} <span class="custom-color">{{
                  motorErrorDetail?.temperature_controller !== null && motorErrorDetail.temperature_controller !== '' && motorErrorDetail.temperature_controller >= 0 && motorErrorDetail.temperature_controller <= 150 ? motorErrorDetail.temperature_controller + ' ℃' : '-'
                }}</span></p>

            </div>
            <div class="battery-flex-item">
              <p>{{ $t('ProductDiagnosis.phaseCurrent') }} <span class="custom-color">{{
                  motorErrorDetail?.phaseCurrent !== null && motorErrorDetail.phaseCurrent !== '' && motorErrorDetail.phaseCurrent >= 0 && motorErrorDetail.phaseCurrent <= 100 ? motorErrorDetail.phaseCurrent + ' A' : '-'
                }}</span></p>

            </div>
          </div>
        </div>

      </template>
    </el-dialog>

  </div>
</template>

<script>
import EventBus from "@/eventBus";
import EmptySlot from "@/components/EmptySlot.vue";
import {recordOperation} from "@/api/api";

export default {
  name: "HistoryFault",
  components: {EmptySlot},
  props: {
    activeTab: String, // 从父页面接收当前激活的 tab 名称
  },
  data() {
    return {
      deviceError: {
        '01': { type: 1, code: 1, zh: "控制器相线过流故障", en: "Controller phase overcurrent fault" },
        '02': { type: 1, code: 2, zh: "控制器母线过流故障", en: "Controller bus overcurrent fault" },
        '03': { type: 1, code: 3, zh: "控制器HALL故障", en: "Controller HALL fault" },
        '05': { type: 1, code: 5, zh: "控制器温度故障", en: "Controller temperature fault" },
        '07': { type: 1, code: 7, zh: "过载故障", en: "Overload fault" },
        '30': { type: 0, code: 30, zh: "通讯仪表故障", en: "Communication meter fault" },
        '60': { type: 0, code: 60, zh: "仪表MCU故障、电压基准故障", en: "Meter MCU fault, voltage reference fault" },
        '06': { type: 1, code: 6, zh: "电机温度故障", en: "Motor temperature fault" },
        '20': { type: 1, code: 20, zh: "推行、电源按键故障", en: "Push, power button fault" },
        '04': { type: 1, code: 4, zh: "刹车故障，转把故障", en: "Brake fault, throttle fault" },
        '10': { type: 1, code: 10, zh: "其它故障", en: "Other faults" },
        '08': { type: 1, code: 8, zh: "控制器通讯故障", en: "Controller communication fault" },
        '09': { type: 1, code: 9, zh: "控制器过压，欠压", en: "Controller overvoltage, undervoltage" },
        '31': { type: 1, code: 31, zh: "MCU故障，基准电压故障，计算周期故障", en: "MCU fault, reference voltage fault, calculation period fault" },
        '32': { type: 0, code: 32, zh: "TE 芯片通讯故障", en: "TE chip communication fault" },
        '34': { type: 0, code: 34, zh: "按键故障", en: "Button fault" },
        '35': { type: 0, code: 35, zh: "按键故障", en: "Button fault" },
        '36': { type: 1, code: 36, zh: "力矩电压故障", en: "Torque voltage fault" },
        '37': { type: 1, code: 37, zh: "刹车故障，车速传感器故障，检测 HALL 故障", en: "Brake fault, speed sensor fault, HALL detection fault" },
        '38': { type: 1, code: 38, zh: "温度传感器故障", en: "Temperature sensor fault" },
        '39': { type: 1, code: 39, zh: "基准采样超时", en: "Reference sampling timeout" },
        '40': { type: 1, code: 40, zh: "电流反馈电路故障", en: "Current feedback circuit fault" },
        '41': { type: 1, code: 41, zh: "驱动电压故障", en: "Drive voltage fault" },
        '42': { type: 1, code: 42, zh: "电流异常故障", en: "Current abnormality fault" },
        '43': { type: 1, code: 43, zh: "电机缺相故障，电机启动停止超时故障", en: "Motor phase loss fault, motor start stop timeout fault" },
        '50': { type: 1, code: 50, zh: "力矩电压检测电路异常", en: "Torque voltage detection circuit abnormality" },
        '61': { type: 0, code: 61, zh: "仪表蓝牙故障", en: "Meter Bluetooth fault" },
        '62': { type: 0, code: 62, zh: "仪表感光故障", en: "Meter photosensitive fault" }
      },

      motorErrorDetail: {},
      historyDetailVisible: false,
      faultData: [], // 故障数据，需要从后端获取或者填充
      isLoading: false,
      tableKey: 0, // 用于强制重新渲染表格容器
    }
  },
  computed: {
    isMotorConnecting() {
      return this.$store.state.isMotorConnecting;
    },
    isBatteryConnecting() {
      return this.$store.state.isBatteryConnecting;
    },
    isDisplayConnecting() {
      return this.$store.state.isDisplayConnecting;
    },
    isMotorConnected() {
      return this.$store.state.isMotorConnected;
    },
    isDisplayConnected() {
      return this.$store.state.isDisplayConnected;
    },
  },
  watch: {
    '$i18n.locale'() {
      if (!(!this.isMotorConnected || this.isMotorConnecting || this.isBatteryConnecting || this.isDisplayConnecting)) {
        this.readFault();
        // 语言切换后强制设置滚动条样式
        this.$nextTick(() => {
          // 强制设置body样式，确保整个页面可以滚动
          document.body.style.overflow = 'auto';
          document.documentElement.style.overflow = 'auto';
          
          // 强制设置表格容器样式
          const tableContainer = this.$refs.tableContainer;
          if (tableContainer) {
            // 强制设置容器样式
            tableContainer.style.overflow = 'hidden';
            tableContainer.style.height = '600px';
            
            // 找到table-wrapper
            const tableWrapper = tableContainer.querySelector('.table-wrapper');
            if (tableWrapper) {
              // 强制设置wrapper样式
              tableWrapper.style.overflowY = 'auto';
              tableWrapper.style.height = '100%';
              tableWrapper.style.width = '100%';
              
              // 强制触发滚动条
              tableWrapper.scrollTop = 1;
              setTimeout(() => {
                tableWrapper.scrollTop = 0;
              }, 100);
            }
          }
        });
      }
    },
    // 监听 activeTab 的变化
    activeTab(newTab) {
      if (newTab === 'history-fault') {
        // 当切换到"历史故障" tab 时，加载故障数据
        this.readFault();
        // 切换标签后强制设置滚动条样式
        this.$nextTick(() => {
          // 强制设置body样式，确保整个页面可以滚动
          document.body.style.overflow = 'auto';
          document.documentElement.style.overflow = 'auto';
          
          // 强制设置表格容器样式
          const tableContainer = this.$refs.tableContainer;
          if (tableContainer) {
            // 强制设置容器样式
            tableContainer.style.overflow = 'hidden';
            tableContainer.style.height = '600px';
            
            // 找到table-wrapper
            const tableWrapper = tableContainer.querySelector('.table-wrapper');
            if (tableWrapper) {
              // 强制设置wrapper样式
              tableWrapper.style.overflowY = 'auto';
              tableWrapper.style.height = '100%';
              tableWrapper.style.width = '100%';
              
              // 强制触发滚动条
              tableWrapper.scrollTop = 1;
              setTimeout(() => {
                tableWrapper.scrollTop = 0;
              }, 100);
            }
          }
        });
      }
    },
  },
  mounted() {
    EventBus.on('reset-all-data', this.clearData);
    EventBus.on('HisErrorResponse', this.handleHisErrorResponse);
  },
  beforeUnmount() {
    EventBus.off('reset-all-data', this.clearData);
    EventBus.off('HisErrorResponse', this.handleHisErrorResponse);
  },
  methods: {
    checkDate(date) {
      const parsedDate = new Date(date);
      if (!date || isNaN(parsedDate.getTime())) return '-';
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
      return parsedDate < oneYearAgo ? '-' : date;
    },
    checkErrCount(count) {
      if (!count || count > 20 || count < 0) return '-';
      return count;
    },
    clearData() {
      this.faultData = [];
    },
    async handleHisErrorResponse(message) {
      try {
        if (message.code === 200) {
          // 解析数据
          let rawData = JSON.parse(message.data);
          
          // 在数据处理层面添加边界检查和修正
          const processedData = rawData.map(item => {
            // 档位边界检查 (0-10)，包含等于10的值
            if (item.gearlevel !== null && item.gearlevel !== undefined) {
              // 使用>而非>=，确保档位=10时能正常显示
              if (item.gearlevel < 0 || item.gearlevel > 10) {
                console.warn(`Invalid gear level: ${item.gearlevel}, setting to '-'`);
                item.gearlevel = null;
              }
            }
            
            // SOC边界检查 (0-100%)，包含等于100的值
            if (item.batterquantity !== null && item.batterquantity !== undefined) {
              // 使用>而非>=，确保SOC=100%时能正常显示
              if (item.batterquantity < 0 || item.batterquantity > 100) {
                console.warn(`Invalid SOC value: ${item.batterquantity}%, setting to '-'`);
                item.batterquantity = null;
              }
            }
            
            // 温度边界检查 (0-150℃)，包含等于150的值
            const temperatureFields = ['temperature_motor', 'temperature_BMS', 'temperature_core', 'temperature_controller'];
            temperatureFields.forEach(field => {
              if (item[field] !== null && item[field] !== undefined) {
                // 使用>而非>=，确保温度=150℃时能正常显示
                if (item[field] < 0 || item[field] > 150) {
                  console.warn(`Invalid temperature value for ${field}: ${item[field]}℃, setting to '-'`);
                  item[field] = null;
                }
              }
            });
            
            // 速度边界检查 (0-100 km/h)，包含等于100的值
            if (item.bikespeed !== null && item.bikespeed !== undefined) {
              // 使用>而非>=，确保速度=100km/h时能正常显示
              if (item.bikespeed < 0 || item.bikespeed > 100) {
                console.warn(`Invalid speed value: ${item.bikespeed} km/h, setting to '-'`);
                item.bikespeed = null;
              }
            }
            
            // 电机转速边界检查 (0-500 rpm)，包含等于500的值
            if (item.RPM !== null && item.RPM !== undefined) {
              // 使用>而非>=，确保转速=500rpm时能正常显示
              if (item.RPM < 0 || item.RPM > 500) {
                console.warn(`Invalid RPM value: ${item.RPM} rpm, setting to '-'`);
                item.RPM = null;
              }
            }
            
            // 母线电流边界检查 (0-60 A)，包含等于60的值
            if (item.busCurrent !== null && item.busCurrent !== undefined) {
              // 使用>而非>=，确保电流=60A时能正常显示
              if (item.busCurrent < 0 || item.busCurrent > 60) {
                console.warn(`Invalid bus current value: ${item.busCurrent} A, setting to '-'`);
                item.busCurrent = null;
              }
            }
            
            // 里程边界检查 (0-100000 km)，包含等于100000的值
            if (item.ODO !== null && item.ODO !== undefined) {
              // 使用>而非>=，确保里程=100000km时能正常显示
              if (item.ODO < 0 || item.ODO > 100000) {
                console.warn(`Invalid mileage value: ${item.ODO} km, setting to '-'`);
                item.ODO = null;
              }
            }
            
            // 相电流边界检查 (0-100 A)，包含等于100的值
            if (item.phaseCurrent !== null && item.phaseCurrent !== undefined) {
              // 使用>而非>=，确保电流=100A时能正常显示
              if (item.phaseCurrent < 0 || item.phaseCurrent > 100) {
                console.warn(`Invalid phase current value: ${item.phaseCurrent} A, setting to '-'`);
                item.phaseCurrent = null;
              }
            }
            
            return item;
          });
          
          this.faultData = processedData;
        } else {
          this.faultData = [];
        }
        
        await this.fetchErrorNames(this.faultData);
        this.isLoading = false; // 数据处理完毕，停止加载
      } catch (error) {
        console.error("An error occurred while processing the fault data:", error);
        this.isLoading = false;
        this.faultData = [];
        await this.fetchErrorNames(this.faultData);
      }
    },
    async readFault() {
      this.isLoading = true; // 开始加载数据
      const ws = this.$store.state.ws;
      if (!ws || ws.readyState !== WebSocket.OPEN) {
        console.error("WebSocket is not connected.");
        this.isLoading = false;
        return;
      }
      // 定义获取电机信息的命令
      const getMotorInfoHisErrorCommand = {
        "cmd": "getMotorInfo_HisError",
        "param": ""
      };
      ws.send(JSON.stringify(getMotorInfoHisErrorCommand));

      try {
        // 记录操作，传递一个包含 action 和 result 的 data 对象
        await recordOperation({ action: 'history-fault' });
      } catch(error) {
        console.error("Failed to record operation:", error);
      }
    },
    fetchErrorNames(faultArray) {
      const currentLocale = this.$i18n.locale;

      this.faultData = faultArray.map(fault => {
        const errorData = this.deviceError[fault.errCode];
        if (errorData) {
          let errName;
          if (currentLocale === 'zh') {
            errName = errorData.zh;
          } else if (currentLocale === 'en') {
            errName = errorData.en;
          } else {
            errName = errorData.en; // 其他语言默认显示英文
          }
          return {
            ...fault,
            errName,
            moduleType: errorData.type === 1 ? this.$t('ProductDiagnosis.motor') : this.$t('ProductDiagnosis.dashboard')
          };
        } else {
          // 为假数据添加默认值
          return {
            ...fault,
            errName: `Test Error ${fault.errCode}`,
            moduleType: this.$t('ProductDiagnosis.motor')
          };
        }
      });

      this.$emit('update-history-fault-data', this.faultData);
      // 数据更新后强制刷新滚动状态
      this.$nextTick(() => {
        this.forceScrollRefresh();
      });
    },

    viewHistoryDetails(row) {
      this.motorErrorDetail = row;
      this.historyDetailVisible = true;
    },

    // 强制刷新滚动状态
    forceScrollRefresh() {
      // 通过更新key来强制重新渲染表格容器
      this.tableKey += 1;
      
      // 重新渲染后确保滚动条正常
      this.$nextTick(() => {
        const tableContainer = this.$refs.tableContainer;
        if (tableContainer) {
          // 强制设置滚动条样式，确保可见
          tableContainer.style.scrollbarWidth = 'thin'; // Firefox
          tableContainer.style.msOverflowStyle = 'scrollbar'; // IE/Edge
          
          // 为WebKit浏览器添加滚动条样式
          const style = document.createElement('style');
          style.textContent = `
            .table-container::-webkit-scrollbar {
              width: 8px;
            }
            .table-container::-webkit-scrollbar-track {
              background: #f1f1f1;
            }
            .table-container::-webkit-scrollbar-thumb {
              background: #888;
              border-radius: 4px;
            }
            .table-container::-webkit-scrollbar-thumb:hover {
              background: #555;
            }
          `;
          document.head.appendChild(style);
          
          // 强制滚动到底部再滚动回顶部，确保滚动条被激活
          const originalScrollTop = tableContainer.scrollTop;
          tableContainer.scrollTop = tableContainer.scrollHeight;
          setTimeout(() => {
            tableContainer.scrollTop = originalScrollTop;
          }, 100);
        }
      });
    },

  }
}
</script>

<style scoped>

.el-table__header th.el-table-column--index {
  writing-mode: horizontal;
}

.table-container {
  position: relative;
  height: 600px; /* 根据实际高度调整 */
  width: 100% !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
}

.table-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto !important;
  padding-right: 8px; /* 为滚动条留出空间 */
  z-index: 1;
  pointer-events: auto;
}

/* 固定滚动条样式 */
.table-wrapper::-webkit-scrollbar {
  width: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Firefox */
.table-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

/* IE/Edge */
.table-wrapper {
  -ms-overflow-style: scrollbar;
}

.scrollbar-placeholder {
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 100%;
  background-color: #f1f1f1;
  pointer-events: none;
}

.read-fault-button {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.battery-flex-container {
  color: rgba(0, 0, 0, 0.45); /* 设置文字颜色和透明度 */
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  /* 允许换行 */
  margin-bottom: 0;
  /* 设置行间距 */
}

.battery-flex-item p {
  padding: 1px;
}

.battery-flex-item {
  flex: 0 0 calc(33.33% - 10px);
  /* 让每个参数占据 33.33% 的宽度，并设置右边距 */
  margin-right: 10px;
  margin-bottom: 0;
}

/* 清除每行最后一个参数的右边距 */
.battery-flex-item:nth-child(3n) {
  margin-right: 0;
}

.my-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.section {
  margin-bottom: 20px;
}

.flex-container {
  color: rgba(0, 0, 0, 0.45); /* 设置文字颜色和透明度 */
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-item {
  width: calc(33.33% - 10px);
  /* 让每个 flex-item 占据 33.33% 的宽度，并留有一些间距 */
  padding: 10px;
}

.err-name-large {
  font-size: 20px; /* 或者你想要的任何大小 */
}

.custom-color {
  color: #000000D9;
}

.custom-button {
  background-color: rgb(245, 245, 245); /* 设置背景色为红色 */
  border-color: rgb(217, 217, 217); /* 设置边框颜色为红色，如果需要 */
  color: rgb(184, 184, 184); /* 设置边框颜色为红色，如果需要 */
}

.custom-button:hover {
  background-color: rgb(245, 245, 245); /* 鼠标悬停时保持相同的背景色 */
  border-color: rgb(217, 217, 217); /* 鼠标悬停时保持相同的边框颜色 */
  color: rgb(184, 184, 184); /* 鼠标悬停时保持相同的文字颜色 */
}

/* 当按钮可点击时应用的样式 */
.button-active {
  background-color: rgb(0, 154, 68); /* 设置背景为白色 */
  color: white; /* 可以调整文字颜色以保持可读性 */
  border-color: #dcdfe6; /* 可选：设置边框颜色 */
}

/* 悬停在 .button-active 上时的样式 */
.button-active:hover {
  color: white; /* 悬停时文字颜色为绿色 */
  border-color: rgb(0, 154, 68); /* 悬停时边框颜色为绿色 */
  background-color: rgb(0, 154, 68); /* 悬停时背景色为白色 */
}

</style>